import { MUTATIONS_KEYS } from '../../store';
import { createWires } from '../wiring.util';
import { WIRE_FACTORY } from './wires.factory';

export const LOCALE_WIRES = createWires({
  storeLocale: WIRE_FACTORY.commitMutation(MUTATIONS_KEYS.config.setLocale),
  storeSearchLocale: WIRE_FACTORY.commitMutation(MUTATIONS_KEYS.config.setSearchLocale),
  storeCurrency: WIRE_FACTORY.commitMutation(MUTATIONS_KEYS.config.setCurrency)
});
